import * as React from "react";
import styled from "styled-components";
import * as googleAnalyticsService from "../../services/google-analytics-service";
import { GoogleAnalyticsEventType } from "../../models/google-analytics";

/** IntroStepBlockElement */
interface IntroStepBlockElementProps {
  /** NUMEREK KROKU */
  elementNumber: number

  /** KOLOR TŁA NUMERKA */
  elementNumberColor: "blue" | "lightgray" | "green"

  /** NAZWA KROKU */
  elementTitle: string

  /** OPIS KROKU */
  elementText: string
}

const IntroStepBlockElement = (props: IntroStepBlockElementProps) => {
  const {elementNumber,elementNumberColor,elementTitle,elementText} = props;
  return (
    <IntroStepBlockElementWrapper className="col-sm-4 wow fadeInUp">
      <div className="shadow-effect">
        <div className="row">
          <div className="col-sm-12 col-md-3">
            <div className={`number ${elementNumberColor}`}>{elementNumber}</div>
          </div>
          <div className="col-sm-12 col-md-9">
            <h4>{elementTitle}</h4>
            <p>{elementText}</p>
          </div>
        </div>
      </div>
    </IntroStepBlockElementWrapper>
  )
};

/** STYLES => IntroStepBlockElement */

const IntroStepBlockElementWrapper = styled.div`
  font-family: 'Roboto' !important;
  div.shadow-effect {
    box-shadow: 0 19px 38px rgba(0, 0, 0, 0.1), 0 15px 12px rgba(0, 0, 0, 0.02), 0 -3px 10px -3px rgba(0,0,0,0.1);
  }
  p {
    font-size: 15px !important;
    font-weight: 400 !important;
  }
`;


/** IntroStepBlock */
interface IntroStepBlockProps {
  /** KROKI => NAJLEPIEJ DOKŁADNIE 3 */
  steps: IntroStepBlockElementProps[]

  /** GOOGLE EVENT TO TRIGGER ON SECTION VIEW */
  componentViewEventType?: GoogleAnalyticsEventType
}

interface IntroStepBlockState {}

class IntroStepBlock extends React.Component<IntroStepBlockProps,IntroStepBlockState> {

  constructor(props: IntroStepBlockProps) {
    super(props);
    this.onComponentView = this.onComponentView.bind(this);
  }

  onComponentView() {
    if (this.props.componentViewEventType) {
      googleAnalyticsService.trackEvent(this.props.componentViewEventType);
    }
  }

  render() {
    const {steps} = this.props;
    return (
      <div className="goodgrowth-theme-styles" onMouseEnter={this.onComponentView}>
        <IntroStepBlockWrapper className="introtext about1">
          <div className="about1-numbers">
            <div className="row">

              {steps.map((step: IntroStepBlockElementProps, index: number) =>
                <IntroStepBlockElement
                  key={index}
                  {...step}
                />
              )}

            </div>
          </div>
        </IntroStepBlockWrapper>
      </div>
    )
  }

}

/** STYLES => IntroStepBlock */

const IntroStepBlockWrapper = styled.section`
  margin-top: -50px;
  padding-top: 10px !important;
`;

export default IntroStepBlock


// WEBPACK FOOTER //
// ./src/layouts/intro-step-block/intro-step-block.tsx